export function getCookie(name) {
  const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
  if (match) {
    return match[1];
  }
  return null;
}

export function deleteCookie(name, path) {
  document.cookie = `${name}=; expires=Thu, 18 Dec 1970 12:00:00 UTC; path=${path}`;
}

export function setCookie(name, value) {
  const cookie = `${name}=${value}`;
  document.cookie = `${cookie}`;
}

export function getFormattedEnvironmentCookie(environment) {
  const environmentCookie = getCookie('mod_env');
  const defaultCookie = environment === 'production'
    ? 'prd_live'
    : 'uat';
  const stagingFlagFormats = {
    uat: 'UAT1',
    uat2: 'UAT2',
    uat3: 'UAT3',
    uat4: 'UAT4',
    prd_live: 'prodLive',
    prd_preview: 'prodPreview'
  };
  const environmentCookieFormater = cookie => {
    const cookieLowerCase = cookie && cookie.toLowerCase() || '';
    return cookieLowerCase && stagingFlagFormats[cookieLowerCase] || '';
  };

  const cookieToFormat = environmentCookie || defaultCookie;

  return environmentCookieFormater(cookieToFormat);
}

export function setEnvironmentCookie(event) {
  const cookie = event && event.target && event.target.value || '';
  // this deletes cookies set by the American Funds bookmark environment switcher
  deleteCookie('mod_env', '/');
  setCookie('mod_env', cookie);
  location.reload();
}

export default {
  getCookie,
  setCookie,
  getFormattedEnvironmentCookie
};
